import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import classnames from 'classnames2';
import styles from './Text.scss';
export var Text = function Text(_ref) {
  var _classes;

  var as = _ref.as,
      children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      dataTest = _ref.dataTest,
      font = _ref.font,
      size = _ref.size,
      weight = _ref.weight,
      rest = _objectWithoutProperties(_ref, ["as", "children", "className", "color", "dataTest", "font", "size", "weight"]);

  var classes = (_classes = {}, _defineProperty(_classes, styles.sizeSmall, size === 'small'), _defineProperty(_classes, styles.sizeMinimum, size === 'minimum'), _defineProperty(_classes, styles.fontCondensed, font === 'condensed'), _defineProperty(_classes, styles.fontBold, font === 'bold'), _defineProperty(_classes, styles.colorLight, color === 'light'), _defineProperty(_classes, styles.colorWhite, color === 'white'), _defineProperty(_classes, styles.colorDisabled, color === 'disabled'), _defineProperty(_classes, styles.weightMedium, weight === 'medium'), _defineProperty(_classes, styles.weightBold, weight === 'bold'), _classes);
  var HtmlElement = as ? as : 'span';
  return React.createElement(HtmlElement, Object.assign({
    "data-test": dataTest,
    className: classnames(styles.text, classes, className)
  }, rest), children);
};
Text.defaultProps = {
  size: 'default',
  font: 'default',
  color: 'default'
};